import moment from "moment";

export const CalcRefreshId = () => moment().format("hh:mm:ss");
